import React from 'react';
import type { ButtonBlock } from '@staty/shared/schemas/block';

/**
 * Button block: renders through the same .staty-btn classes the public page
 * uses; the LABEL is edited inline on the button itself. URL/style/alignment
 * live in the settings panel (a link that navigated while editing would be
 * hostile, so the anchor is inert here).
 */

interface Props {
  block: ButtonBlock;
  onChange: (patch: Partial<ButtonBlock>) => void;
}

export default function ButtonBlockEditor({ block, onChange }: Props) {
  return (
    <div className="staty-block staty-block--button" data-align={block.alignment || 'left'}>
      <span className={`staty-btn staty-btn--${block.style || 'primary'} canvas-btn-editable`}>
        <input
          type="text"
          value={block.label}
          placeholder="Button label"
          // Grow with the label: the stylesheet's 12ch fits hand-typed CTAs,
          // but filename-derived Document labels are routinely longer and
          // would visually clip on the canvas (the public anchor is fine).
          style={{ width: `${Math.max(block.label.length, 12)}ch` }}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => onChange({ label: e.target.value })}
          aria-label="Button label"
        />
      </span>
    </div>
  );
}
